import { render, staticRenderFns } from "./UserFormPage.vue?vue&type=template&id=7ca9a8ae"
import script from "./UserFormPage.vue?vue&type=script&lang=js"
export * from "./UserFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports